import Vue from 'vue'
import VueRouter from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: () => import('@/views/home.vue'),
  meta: {
    authRequired: true
  }
}, {
  path: '/home',
  component: () => import('@/views/home.vue'),
  meta: {
    authRequired: true
  }
}, {
  path: '/my',
  component: () => import('@/views/my.vue'),
  meta: {
    authRequired: true
  }
},
  {
    path: '/login',
    component: () => import('@/views/login.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/question',
    component: () => import('@/views/question.vue'),
    meta: {
      authRequired: true
    }
  },

  {
    path: '/allmission',
    component: () => import('@/views/allmission.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/allsquadendmission',
    component: () => import('@/views/allsquadendmisssion.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/questionfenxi/:id',
    component: () => import('@/views/questionfenxi.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/course-plan',
    component: () => import('@/views/course-plan.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/admin',
    component: () => import('@/views/admin.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/authrole',
    component: () => import('@/views/authrole.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/authrule',
    component: () => import('@/views/authrule.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/basicgrade',
    component: () => import('@/views/basicgrade.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/basicsemester',
    component: () => import('@/views/basicsemester.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/authcategory',
    component: () => import('@/views/authcategory.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/basiccourse',
    component: () => import('@/views/basiccourse.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/basicchapter',
    component: () => import('@/views/basicchapter.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/questionnode',
    component: () => import('@/views/questionnode.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/questiontype',
    component: () => import('@/views/questiontype.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/questiontestpapertype',
    component: () => import('@/views/questiontestpapertype.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/questiontestpaper',
    component: () => import('@/views/questiontestpaper.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/basicmission',
    component: () => import('@/views/basicmission.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/orgorganizationinfo',
    component: () => import('@/views/orgorganizationinfo.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/basicmission',
    component: () => import('@/views/basicmission.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/orgorganization',
    component: () => import('@/views/orgorganization.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/orgcampus',
    component: () => import('@/views/orgcampus.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/orgcampusteacher',
    component: () => import('@/views/orgcampusteacher.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/orgsquad',
    component: () => import('@/views/orgsquad.vue'),
    meta: {
      authRequired: true
    }
  }, {
    path: '/user',
    component: () => import('@/views/user.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/orgquadinfo',
    component: () => import('@/views/orgquadinfo.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/test',
    component: () => import('@/views/test.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/missiontype',
    component: () => import('@/views/basicmissiontype.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/orgcampusinfo',
    component: () => import('@/views/orgcampusinfo.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/chapter',
    component: () => import('@/views/chapter.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/task-statistics',
    component: () => import('@/views/task-statistics.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/class-statistics',
    component: () => import('@/views/class-statistics.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/missionsimilarinfo',
    component: () => import('@/views/missionsimilarinfo.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/suggest',
    component: () => import('@/views/suggest.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/studentlecture',
    component: () => import('@/views/studentlecture.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/studentlecturestatistic',
    component: () => import('@/views/studentlecturestatistic.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/studenthomework',
    component: () => import('@/views/student-homework.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/studentexamscore',
    component: () => import('@/views/studentexamscore.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/studentexam',
    component: () => import('@/views/studentexam.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/chaptertestpaper',
    component: () => import('@/views/orgpublish/chaptertestpaper.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/chapterlist',
    component: () => import('@/views/basic/chapterlist.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/org_user_analyse',
    component: () => import('@/views/dataanalyse/org_user_analyse.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/teacher_user_analyse',
    component: () => import('@/views/dataanalyse/teacher_user_analyse.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/mission_org_analyse',
    component: () => import('@/views/dataanalyse/mission_org_analyse.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/teacher_comment',
    component: () => import('@/views/dataanalyse/teacher_comment_analyse.vue'),
    meta: {
      authRequired: true
    }
  },

  {
    path: '/mission_yuxiinfo',
    component: () => import('@/views/dataanalyse/mission_yuxiinfo.vue'),
    meta: {
      authRequired: true
    }
  },

  {
    path: '/chaptermissioninfo',
    component: () => import('@/views/dataanalyse/chaptermissioninfo'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/teachermissioninfo',
    component: () => import('@/views/dataanalyse/teachermissioninfo'),
    meta: {
      authRequired: true
    }
  },

  {
    path: '/basicsetconfig',
    component: () => import('@/views/basicsetconfig'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/student',
    component: () => import('@/views/student.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/operate',
    component: () => import('@/views/operate.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/wagestatistics',
    component: () => import('@/views/performance/wagestatistics.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/bodyrowData',
    component: () => import('@/views/performance/bodyrowData.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/teacherlecturestatistic',
    component: () => import('@/views/teacherlecturestatistic.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/regstudentstatistic',
    component: () => import('@/views/reg_student_statistics.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/correctmeeponum',
    component: () => import('@/views/correctmeeponum.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/attendance',
    component: () => import('@/views/attendance.vue'),
    meta: {
      authRequired: true
    }
  },{
    path: '/attendancefind',
    component: () => import('@/views/attendancefind.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path:'/ad',
    component:()=>import('@/views/adver/index.vue'),
    meta:{
      authRequired:true
    },
    children:[
      {
        path:'ad',
        component:()=>import('@/views/adver/adver.vue')
      },{
        path:'adtype',
        component:()=>import('@/views/adver/position.vue')
      }
    ]
  },{
    path:'/appdownload',
    component:()=>import('@/views/appdownload.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/testpaper',
    component:()=>import('@/views/testpaper.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/ksinfo',
    component:()=>import('@/views/ksinfo.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/ksinfo_teacher',
    component:()=>import('@/views/ksinfoTeacher.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/accessRecord',
    component:()=>import('@/views/accessRecord.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/exam-student',
    component:()=>import('@/views/exam-student.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/studentInfo',
    component:()=>import('@/views/studentInfo.vue'),
    meta:{
      authRequired:true
    }
  },
  {
    path:'/oldstudent',
    component:()=>import('@/views/oldstudent.vue'),
    meta:{
      authRequired:true
    }
  },{
    path:'/classParam',
    component:()=>import('@/views/classParam.vue'),
    meta:{
      authRequired:true
    }
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.authRequired) {
    const token = localStorage.getItem('token');
    if (token) {
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
})

export default router
